module.exports = __webpack_public_path__ + "static/covid-90caf49ca4fb1fc3cf4fa69b462a1cf7.jpg";